import { z } from 'zod'

// Transaction statuses (transactions.status), not payment statuses.
export const TransactionStatusSchema = z.number().transform((value) => {
  switch (value) {
    case 1:
      return 'Approved'
    case 2:
      return 'Declined'
    case 3:
      return 'In review'
    case 4:
      return 'Refunded by Provider'
    case 5:
      return 'Partially Refunded by Provider'
    case 6:
      return 'Partial Refund in Progress'
    default:
      return 'Unknown'
  }
})

export type TransactionStatus = z.infer<typeof TransactionStatusSchema>
